export default __webpack_public_path__ + "static/media/JCI.981f3920.png";